import usePrivateLink from "../config/usePrivateLink";
import React, { useEffect, useRef, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Swal from "sweetalert2";
import { StudentAdmission, StudentList, StudentListAll } from "../../api/StudentServices";
import { formatDate, ToastMain ,SweetAlertShow} from "../master/Master";
import { getSessions } from "../../api/SessionsService";
import { courseList } from "../../api/Courses";
import { Link, useLocation } from "react-router-dom";
import DownloadExcel from "../master/DownloadExcel";
import { useNavigate } from "react-router-dom";
import { getBatchList, viewlist } from "../../api/BatchService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { formatToDate } from "../master/FormatToDateTime";

export default function StudentsList() {
  const hasAccess = usePrivateLink();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState("");
  const [students, setStudents] = useState("");
  const [sessions, setSessions] = useState([]);
  const [courses, setCourses] = useState([]);
  const [page, setPage] = useState(1);
  const [addUrl, setAddUrl] = useState("");
  const [batchList, setBatchList] = useState([]);
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [course_id, setCourseId] = useState("");
  const [session_id, setSessionId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [rowErrors, setRowErrors] = useState({}); // { index: { field: errorMsg } }
  const [selectedSession, setSelectedSessions] = useState("");
  // this data is dummy
  const [statuses, setStatuses] = useState([]); // ['pending', 'success', 'failed']
  const [batch, setBatch] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [delay, setDelay] = useState(1000); // in ms
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [startDate, setStartDate] = useState(
    queryParams.get("start_date") || ""
  );
  const [error, setError] = useState("");
  const [selectedBatchId, setSelectedBatchId] = useState("");

  const batchliststudent = async () => {
    const addUrl = `&session_id=${selectedSession}`;
    setLoading(true);
    try {
      console?.log("Fetching batches with status:", status); // ✅ Debugging log
      const response = await viewlist(addUrl);
      console?.log(
        "Batchlist response",
        response?.data?.batches?.[0]?.batch_fees
      );

      if (response?.data?.status) {
        setBatch(response?.data || []);
        console?.log("Batch fetched", response?.data?.batches);
      } else {
        setError("Failed to fetch batches?.");
      }
    } catch (error) {

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message  ?? error?.message)
   
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedSession) {
      batchliststudent();
    }
  }, [selectedSession]);

  const intervalRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);

    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(sheet, { raw: false });

      setExcelData(rows);
      setStatuses(Array(rows.length).fill("pending"));
      setCurrentIndex(0);
    };
    reader.readAsBinaryString(file);
  };
  const updateStatus = (index, status) => {
    setStatuses((prev) => {
      const newStatuses = [...prev];
      newStatuses[index] = status;
      return newStatuses;
    });
  };

  useEffect(() => {
    const getBatches = async () => {
      setLoading(true);
      try {
        const response = await getBatchList();
        if (response.data.status) {
          setBatches(response.data.batches);
        } else {

          SweetAlertShow('info','Warning',response?.data?.message)
          
        }
      } catch (error) {
        SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
      
      } finally {
        setLoading(false);
      }
    };
    getBatches();
  }, []);

  const formatDate = (excelDate) => {
    // return '1234567890';
    if (!excelDate) return "";

    // Case 1: Agar already string hai (Excel se "8-May-24" jaisa aaya)
    if (typeof excelDate === "string") {
      const parsed = new Date(excelDate);
      if (!isNaN(parsed)) {
        return parsed.toISOString().split("T")[0]; // YYYY-MM-DD
      }
      return excelDate; // agar parse na ho paya to original string bhej do
    }

    // Case 2: Agar number hai (Excel serial number jaise 45420)
    if (typeof excelDate === "number") {
      const date = new Date((excelDate - 25569) * 86400 * 1000);
      if (!isNaN(date)) {
        return date.toISOString().split("T")[0];
      }
      return "";
    }

    return ""; // fallback
  };

  const uploadRow = async (index) => {
    const row = { ...excelData[index] };
    if (selectedBatch) {
      row.batch_id = selectedBatch;
    }
    const formData = new FormData();

    Object.entries(row).forEach(([key, val]) => {
      if (key === "admission_date") {
        formData.append(key, formatDate(val));
      } else {
        formData.append(key, val ?? "");
      }
    });

    // Object.entries(row).forEach(([key, val]) =>
    //   formData.append(key, val ?? "")
    // );
    try {
      const res = await StudentAdmission(formData);

      if (res.status === false && res.errors) {
        updateStatus(index, "failed");
        setRowErrors((prev) => ({
          ...prev,
          [index]: res.errors,
        }));
        return;
      }

      updateStatus(index, "success");
    } catch (error) {
      console.error(`Upload failed for row ${index}`, error);
      updateStatus(index, "failed");

      if (error.response?.data?.errors) {
        setRowErrors((prev) => ({
          ...prev,
          [index]: error.response.data.errors,
        }));
      }
    }
  };

  const handleUpload = async () => {
    if (!excelData.length) return alert("No data");

    // setLoading(true);

    const processRow = async (index) => {
      if (index >= excelData.length) {
        setLoading(false);
        return;
      }

      if (statuses[index] === "pending") {
        await uploadRow(index);
        // delay between calls
        await new Promise((res) => setTimeout(res, delay));
      }

      if (statuses[index] === "failed") {
        // Stop loop on failure
        setCurrentIndex(index);
        // setLoading(false);
        return;
      }

      setCurrentIndex(index + 1);
      await processRow(index + 1);
    };

    processRow(currentIndex);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => prev + 1);
    handleUpload();
  };

  const handleRepair = (index) => {
    updateStatus(index, "pending");
    setRowErrors((prev) => {
      const updated = { ...prev };
      delete updated[index];
      return updated;
    });
    setCurrentIndex(index);
    handleUpload();
  };

  const countStatus = (type) =>
    statuses.filter((status) => status === type).length;

  const handleDownloadFormat = () => {
    const data = [
      [
        "registration",
        "name",
        "father_name",
        "mother_name",
        "mobile",
        "secondary_phone",
        "gender",
        "email",
        "category",
        "aadhar",
        "dob",
        "nic_id",
        "apaar_id",
        "rte",
        "village",
        "state",
        "district",
        "pincode",
        "education",
        "school_name",
        "referred_by",
        "batch_id",
        "reg_fee",
        "total_fee",
        "batch_discount",
        "discount_remark",
        "emiCheckbox",
        "total_emi",
        "emi_amount_1",
        "emi_date_1",
        "emi_amount_2",
        "emi_date_2",
        "emi_amount_3",
        "emi_date_3",
        "emi_amount_4",
        "emi_date_4",
        "bus_route_id",
        "bus_id",
        "bus_fees",
        "bus_final_fees",
        "bus_discount",
        "image",
      ],
      [
        "1019",
        "DAYA",
        "MASURI",
        "HASURRI",
        "9306487930",
        "1234567890",
        "Male",
        "monuyadav@gmail.com",
        "OBC",
        "123443211234",
        "2025-08-01",
        "3456738jhfkdls",
        "gfhjklsfdaj",
        "NON-RTE",
        "Chomu",
        "Chomu",
        "Haryana",
        "Bhiwani",
        "000409",
        "BA Pass",
        "Shree Bala Ji",
        "Manoj Yadav",
        "28",
        "2000",
        "13000",
        "2000",
        "By Monu",
        "1",
        "4",
        "3250",
        "2025-08-25",
        "3250",
        "2025-09-25",
        "3250",
        "2025-10-25",
        "3250",
        "2025-11-25",
        "8",
        "6",
        "1200.00",
        "1000.00",
        "200",
        "student.jpg",
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "students_template.xlsx");
  };

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions();
      if (response?.data?.status) {
        setSessions(response?.data?.data);
        const activeSession = response?.data?.data?.find(
          (s) => s.status === "1"
        );
        // setSelectedSessions(activeSession.id);
      } else {

        SweetAlertShow('info','Warning',response?.data?.message)
    
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
 
    } finally {
      setLoading(false);
    }
  };
  const courseFetch = async () => {
    setLoading(true);
    try {
      const response = await courseList();
      if (response.data.status) {
        setCourses(response?.data?.data || []);
      } else {
        SweetAlertShow('info','Warning',response?.data?.message)
        
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
      
    } finally {
      setLoading(false);
    }
  };

  const getStudents = async () => {
    setLoading(true);
    let url =
      addUrl +
      `&page=${page}&session_id=${selectedSession}&start_date=${startDate}&batch_id=${selectedBatchId}`;
    try {
      const response = await StudentListAll(url);
      if (response.data.status) {
        // alert('qwerty')
        setStudents(response?.data?.data);
      } else {
        SweetAlertShow('info','Warning',response?.data?.message)
  
      }
    } catch (error) {
      SweetAlertShow('error','Error', error?.response?.data?.message  ?? error?.response?.message ?? error?.message)
    
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStudents();
  }, [addUrl, page, selectedSession, startDate, selectedBatchId]);

  useEffect(() => {
    getSession();
    courseFetch();
  }, []);

  const handleFilter = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const queryString = new URLSearchParams(formData).toString();
    setAddUrl(`&${queryString}`);
  };

  const handleDownloadAll = async () => {
    try {
      let url = `${addUrl}&session_id=${selectedSession}`;
      if (startDate) url += `&start_date=${startDate}`;
      // if (endDate) url += `&end_date=${endDate}`;
      if (selectedBatchId) url += `&batch_id=${selectedBatchId}`;

      setLoading(true);
      let allData = [];

      // ✅ Fetch first page to determine last page
      const firstResponse = await StudentList(`${url}&page=1`);
      const lastPage = firstResponse?.data?.data?.last_page || 1;

      // ✅ Fetch all pages
      for (let p = 1; p <= lastPage; p++) {
        const response = await StudentList(`${url}&page=${p}`);
        const records = response?.data?.data?.data || [];
        allData.push(...records);
      }

      if (allData.length === 0) {
        alert("No data to export!");
        return;
      }

      // ✅ Format and safely map required fields
      const formattedData = allData.map((item, index) => {
        const fee = item.fee_info || {};
        const batch = fee.batch || {};
        const course = fee.course || {};
        const session = fee.session_year || {};

        return {
          "Sr #": index + 1,
          "Registration No": item.registration_no || "",
          "Student Name": item.name || "",
          "Father Name": item.father_name || "",
          Mobile: item.phone || "",
          Gender: item.gender || "",
          DOB: item.dob || "",
          Village: item.village || "",
          District: item.district || "",
          State: item.state || "",
          Course: course.title || "N/A",
          Batch: batch.title || "N/A",
          Session: session.session || "N/A",
          "Admission Date": fee.admission_date
            ? new Date(fee.admission_date).toLocaleDateString()
            : item.admission_date || "",
          "Total Fee": fee.total_fee || 0,
          "Paid Fee": fee.fees_paid || 0,
          "Left Amount": fee.left_amount || 0,
          "Reg Fee": fee.reg_fee || 0,
          Discount: fee.batch_discount || 0,
          RTE: fee.rte || "",
          "Next Payment Date": fee.next_payment_date || "",
          "Roll No": fee.roll_number || "",
          Status: item.status === "1" ? "Active" : "Inactive",
          // "Created At": item.created_at
          //   ? new Date(item.created_at).toLocaleString()
          //   : "",
          // "Updated At": item.updated_at
          //   ? new Date(item.updated_at).toLocaleString()
          //   : "",
        };
      });

      // ✅ Create Excel sheet
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Student_List");

      // ✅ Adjust column widths for readability
      const colWidths = Object.keys(formattedData[0]).map(() => ({ wch: 20 }));
      worksheet["!cols"] = colWidths;

      // ✅ Add filename with current date
      const dateStr = new Date().toISOString().split("T")[0];
      XLSX.writeFile(workbook, `Student_List_${dateStr}.xlsx`);

      alert(`✅ Exported ${allData.length} student records successfully!`);
    } catch (error) {
      console.error("Export error:", error);
      alert(`❌ Error while exporting: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleAdmitStudentClick = async () => {
    try {
      const addUrl = `&status=${status}&session_id=${session_id}&course_id=${course_id}`;
      const response = await getBatchList(addUrl);
      console.log("Batch List:", response.data);

      if (response.data.status && response.data.batches.length > 0) {
        navigate("/student/add");
      } else {
        Swal.fire({
          title: "No Batch Found!",
          text: "You need to add a batch before admitting student.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Go to Batch Page",
          cancelButtonText: "Cancel",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/Batches");
          }
        });
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.response?.message ?? error?.message)
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something went wrong!",
      // });
    }
  };
return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-2">
                      <h4 className="text-primary mb-0"> Student List </h4>

                      <div className="d-flex gap-2 flex-wrap">
                        {hasAccess('/student/add') && (
                          <button
                            className="btn btn-primary d-inline-flex align-items-center overflow-hidden transition-button"
                            onClick={handleAdmitStudentClick}
                          >
                            <span className="icon">
                              <i className="bi bi-plus-circle-dotted"></i>
                            </span>
                            <span className="text ms-1">Admit Student</span>
                          </button>
                        )}
                        {hasAccess('/students/import') && (
                          <button
                            className="btn btn-info btn-sm"
                            data-bs-toggle="modal"
                            data-bs-target="#excelUploadModal"
                          >
                            <i className="bi bi-cloud-arrow-up ri-20px"></i>
                          </button>
                        )}
                        {hasAccess('/students/export') && (
                          <button
                            className="btn btn-success btn-sm"
                            onClick={handleDownloadAll}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Export Excel"
                          >
                            <i className="bi bi-cloud-arrow-down ri-20px"></i>
                          </button>
                        )}
                      </div>
                    </div>

                    <form className="row" onSubmit={handleFilter}>
                      <div className="col-md-3 form-floating form-floating-outline mb-5 mt-2 fv-plugins-icon-container">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Student Name/Mobile/Registr"
                          name="search"
                          onChange={(e) => {
                            e.target.value = e.target.value.toUpperCase();
                          }}
                        />
                        <label className="ms-5">Name/Mobile/Reg. No</label>
                      </div>
                      <div className="col-md-3  form-floating form-floating-outline mb-5 mt-2 fv-plugins-icon-container">
                        <input
                          type="text"
                          className="form-control input-uppercase"
                          placeholder="Village/District/Pincode"
                          name="address"
                        />
                        <label className="ms-5">By Address</label>
                      </div>
                      <div className="col-md-3 form-floating form-floating-outline mb-5 mt-2 fv-plugins-icon-container">
                        <select
                          className="form-select form-control"
                          name="session_id"
                          value={selectedSession}
                          onChange={(e) => setSelectedSessions(e.target.value)}
                        >
                          <option selected disabled>
                            Select Session
                          </option>
                          {sessions.map((item) => (
                            <option
                              key={item.id}
                              value={item.id}
                              selected={item?.status === "1" && true}
                            >
                              {item.session}:
                              {item.status == "1" ? "Active" : "Inactive"}
                            </option>
                          ))}
                        </select>
                        <label className="ms-5">Fillter Session</label>
                      </div>
                      <div className="col-md-3 form-floating form-floating-outline mb-2 mt-2 fv-plugins-icon-container">
                        <select
                          className="form-select form-control"
                          name="course_id"
                        >
                          <option value="">All Courses / Classes</option>
                          {courses.map((course, index) => (
                            <option key={index} value={course.id}>
                              {course.title}
                            </option>
                          ))}
                        </select>
                        <label className="ms-5">Course</label>
                      </div>

                      <div className="col-md-3 form-floating form-floating-outline">
                        <select
                          className="form-control"
                          onChange={(e) => setSelectedBatchId(e.target.value)}
                          value={selectedBatchId}
                        >
                          <option value="">Select Batch</option>
                          {batch?.batches?.map((batch) => (
                            <option key={batch?.id} value={batch?.id}>
                              {batch?.title}
                            </option>
                          ))}
                        </select>
                        <label>Select Batch</label>
                      </div>

                      <div className="col-md-3 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                        <input
                          type="date"
                          className="form-control"
                          placeholder="Admission From Date"
                          name="start_date"
                        />
                        <label className="ms-5">Admission From Date</label>
                      </div>

                      <div className="col-md-3 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                        <input
                          type="date"
                          className="form-control"
                          name="end_date"
                        />
                        <label className="ms-5">Admission To Date</label>
                      </div>
                      <div className="col-md-3 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                        <input
                          type="text"
                          className="form-control"
                          name="school"
                          placeholder="School"
                        />
                        <label className="ms-5">School</label>
                      </div>

                      <div className="col-md-4 col-sm-5">
                        <button
                          type="submit"
                          className="btn btn-label-primary me-1"
                        >
                          <i className="ri-arrow-right-line ri-20px" />
                        </button>
                        <a href="?" className="btn btn-label-danger me-1">
                          <i className="ri-restart-line ri-20px" />
                        </a>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <h6 className="text-black">
                      Total Students: -{" "}
                      <span className="text-primary">{students?.total}</span>
                    </h6>

                    <div className="table-responsive ">
                      <table className="table table-hover table-sm">
                        <thead>
                          <tr className="text-center text-nowrap">
                            <th>#</th>
                            <th>Name</th>
                            <th>Father's Name</th>
                            <th>Mobile No</th>
                            <th>Batch</th>
                            <th>Address</th>
                            <th>Admission Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {students?.data?.length > 0 ? (
                            students?.data?.map((student, index) => (
                              <tr key={student.id}>
                                <td>{index + 1}</td>
                                <td>
                                  {student.name} ({student.registration_no})
                                </td>
                                <td>{student.father_name}</td>
                                <td>{student.phone}</td>
                                <td>{student?.fee_info?.batch?.title}</td>
                                <td>
                                  {student?.village}{" "}
                                  {student?.district} {student?.state}{" "}
                                  {student?.zipcode}{" "}
                                </td>
                                <td>{formatToDate(student?.admission_date)}</td>
                                <td>
                                  <div className="demo-inline-spacing py-0 my-0">
                                    <div
                                      className="btn-group py-0 my-0"
                                      id="hover-dropdown-demo"
                                    >
                                      <button
                                        type="button"
                                        className="btn dropdown-toggle py-0 my-0"
                                        data-bs-toggle="dropdown"
                                        data-trigger="hover"
                                        aria-expanded="false"
                                      >
                                        <i className="bi bi-three-dots-vertical" />
                                      </button>
                                      <ul className="dropdown-menu py-0">
                                        <li>
                                          {hasAccess('/student/details') && (
                                            <Link
                                              to={`/student/details?id=${student.id}`}
                                              className="dropdown-item"
                                            >
                                              <i className="bi bi-eye text-success mx-1"></i>
                                              View
                                            </Link>
                                          )}
                                        </li>
                                        <li>
                                          {hasAccess('/student/update') && (
                                            <Link
                                              to={`/student/update?id=${student.id}`}
                                              className="dropdown-item"
                                            >
                                              <i className="bi bi-pencil-square text-primary mx-1"></i>
                                              Edit
                                            </Link>
                                          )}
                                        </li>
                                        <li>
                                          {/* {(permissions?.[0]?.role_id == '1' || permissions?.find((permission) => permission?.route?.frontend_url == '/student/delete')) && (
                                          <button
                                            className="dropdown-item"
                                            onClick={() =>
                                              Swal.fire({
                                                title: "Are you sure?",
                                                text: "This action will permanently delete the Student!",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "#d33",
                                                cancelButtonColor: "#6c757d",
                                                confirmButtonText:
                                                  "Yes, delete it!",
                                                cancelButtonText: "Cancel",
                                              })
                                            }
                                          >
                                            <i className="bi bi-trash-fill mx-1 text-danger"></i>{" "}
                                            Delete
                                          </button>
                                          )} */}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9">No students found.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <nav aria-label="Page navigation" className="mt-10">
                        <p>
                          Showing {students?.from} to {students?.to} of{" "}
                          {students?.total} entries
                        </p>
                        <ul className="pagination pagination-sm">
                          {students?.links?.map((btn, i) => (
                            <li
                              className={`page-item  ${
                                btn?.active && "active"
                              }  ${btn?.url ? "" : "disabled"} `}
                            >
                              <button
                                className="page-link waves-effect"
                                onClick={() => {
                                  if (students?.links?.length === i + 1) {
                                    btn?.url &&
                                      setPage(students?.current_page + 1);
                                  } else if (i === 0) {
                                    btn?.url &&
                                      setPage(students?.current_page - 1);
                                  } else {
                                    setPage(btn.label);
                                  }
                                }}
                              >
                                {students?.links?.length == i + 1 ? (
                                  <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                                ) : i == 0 ? (
                                  <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                                ) : (
                                  btn?.label
                                )}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 
      {showModal && (
        <div className="modal fade show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Upload Students Excel</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  type="file"
                  accept=".xls,.xlsx,.csv"
                  className="form-control mb-3"
                  onChange={handleFileChange}
                />
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={handleDownloadFormat}
                >
                  Download Format
                </button>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={handleUpload}
                  disabled={!selectedFile}
                >
                  Upload
                </button>
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {/* Preview Modal */}
      <div
        className="modal fade"
        id="excelUploadModal"
        tabIndex="-1"
        aria-labelledby="excelUploadModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-xl">
          <div className="modal-content shadow-lg rounded-3">
            {/* HEADER */}
            <div className="modal-header bg-label-primary p-3 text-white d-flex justify-content-between align-items-center rounded-top-3">
              <h5 className="modal-title fw-bold" id="excelUploadModalLabel">
                🧾 Excel Data Preview
              </h5>
              <h5 className="mb-3 text-primary">📤 Upload Excel</h5>
              {/* <button
          type="button"
          className="btn-close btn-close-white"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button> */}
            </div>

            {/* BODY */}
            <div className="modal-body">
              <div className="container-fluid">
                <div className="d-flex flex-wrap align-items-center mb-3 gap-2">
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                    className="form-control w-50"
                  />

                  <select
                    value={selectedBatch}
                    onChange={(e) => setSelectedBatch(e.target.value)}
                    className="form-select w-auto"
                  >
                    <option value="" selected disabled>
                      Select Batch
                    </option>
                    {batches?.map((batch, i) => (
                      <option key={batch?.id} value={batch?.id}>
                        {batch.title} ({batch?.course?.title})
                      </option>
                    ))}
                  </select>

                  <select
                    value={delay}
                    onChange={(e) => setDelay(Number(e.target.value))}
                    className="form-select w-auto"
                  >
                    {[...Array(15)].map((_, i) => (
                      <option key={i} value={(i + 1) * 1000}>
                        Delay: {i + 1}s
                      </option>
                    ))}
                  </select>

                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleDownloadFormat}
                  >
                    Dummy Data
                  </button>
                </div>

                {/* Status */}
                <div className="alert alert-light border mb-3 p-2 small">
                  ✅ Success: {countStatus("success")} | ❌ Failed:{" "}
                  {countStatus("failed")} | ⏳ Pending: {countStatus("pending")}
                </div>

                {/* Table Section with Scroll */}
                {excelData.length > 0 && (
                  <div
                    className="table-responsive"
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                  >
                    <table className="table table-bordered table-hover align-middle">
                      <thead
                        className="table-primary sticky-top"
                        style={{ zIndex: 5 }}
                      >
                        <tr>
                          <th style={{ width: "50px" }}>#</th>
                          {Object.keys(excelData[0]).map((key, idx) => (
                            <th key={idx}>{key}</th>
                          ))}
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {excelData.map((row, idx) => (
                          <tr key={idx}>
                            <td className="fw-bold">{idx + 1}</td>
                            {Object.keys(row).map((key, i) => (
                              <td key={i}>
                                {statuses[idx] === "failed" ? (
                                  <div>
                                    <input
                                      type="text"
                                      className={`form-control form-control-sm ${
                                        rowErrors?.[idx]?.[key]
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      value={row[key]}
                                      onChange={(e) => {
                                        const newData = [...excelData];
                                        newData[idx][key] = e.target.value;
                                        setExcelData(newData);
                                      }}
                                    />
                                    {rowErrors?.[idx]?.[key] && (
                                      <div className="invalid-feedback">
                                        {rowErrors[idx][key][0]}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  row[key]
                                )}
                              </td>
                            ))}
                            <td>
                              {statuses[idx] === "success" && "✅"}
                              {statuses[idx] === "failed" && "❌"}
                              {statuses[idx] === "pending" && "⏳"}
                            </td>
                            <td>
                              {statuses[idx] === "failed" && (
                                <button
                                  className="btn btn-sm btn-outline-info"
                                  onClick={() => handleRepair(idx)}
                                >
                                  Retry
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* Upload Button */}
                {/* <div className="mt-4 text-end">
            <button
              className="btn btn-primary px-4"
              onClick={handleUpload}
              disabled={loading || !excelData.length}
            >
              {loading ? "Uploading..." : "🚀 Start Upload"}
            </button>
          </div> */}
              </div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-outline-primary"
                data-bs-dismiss="modal"
              >
                ❌ Cancel
              </button>
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-label-primary"
                  onClick={handleUpload}
                  disabled={loading}
                >
                  {loading ? "Uploading..." : "🚀 Start Upload"}
                </button>
                <button
                  className="btn btn-warning"
                  onClick={() => {
                    const firstFailed = statuses.findIndex(
                      (s) => s === "failed"
                    );
                    if (firstFailed !== -1) {
                      setCurrentIndex(firstFailed);
                      handleUpload();
                    }
                  }}
                >
                  🔁 Retry Failed
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
